import { render, staticRenderFns } from "./ExternalPrintActDetail.vue?vue&type=template&id=3b237556&scoped=true&"
import script from "./ExternalPrintActDetail.vue?vue&type=script&lang=ts&"
export * from "./ExternalPrintActDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalPrintActDetail.vue?vue&type=style&index=0&id=3b237556&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b237556",
  null
  
)

export default component.exports